import React from 'react';

const editableClue = (props) => {
  return (
    <React.Fragment>
      <dt className="clueNumber">{props.clueNumber}</dt>
      <dd className="clueValue">
        <input type="text"
               value={props.children}
               onChange={props.onClueChange} placeholder={props.answer}
               disabled={!props.enabled} />
      </dd>
    </React.Fragment>
  );
};

export default editableClue;
